import { render, staticRenderFns } from "./AttendeeListGift.vue?vue&type=template&id=181d5926&"
import script from "./AttendeeListGift.vue?vue&type=script&lang=js&"
export * from "./AttendeeListGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports